// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { generateDynamicGridItemStyle } from "@hardwoods/App/Widgets/DesignSystem/DesignSystem.utils";
import { longText } from "@hardwoods/App/Widgets/DesignSystem/DummyData";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import Moon from "@insite/mobius/Icons/Moon";
import Link from "@insite/mobius/Link";
import Tooltip from "@insite/mobius/Tooltip";
import Typography from "@insite/mobius/Typography";
import React from "react";

export const XdlTooltip = () => {
    const triggerLink = <Link as="span">this?</Link>;
    return (
        <GridContainer>
            <GridItem {...generateDynamicGridItemStyle(3, 2)}>
                <Typography>Tooltip with long text</Typography>
                <Tooltip text={longText} />
            </GridItem>
            <GridItem {...generateDynamicGridItemStyle(3, 2)}>
                <Typography>Tooltip with icon</Typography>
                <Tooltip iconProps={{ src: Moon }} text="Night mode" />
            </GridItem>
            <GridItem {...generateDynamicGridItemStyle(3, 2)}>
                <Typography>Tooltip with trigger link</Typography>
                <Tooltip triggerComponent={triggerLink} text="custom trigger" />
            </GridItem>
        </GridContainer>
    );
};
